"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _PieChartFilled = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/PieChartFilled"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PieChartFilled = function PieChartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _PieChartFilled.default
  }));
};

/**![pie-chart](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2My4xIDUxOC41SDUwNS41VjE2MC45YzAtNC40LTMuNi04LTgtOGgtMjZhMzk4LjU3IDM5OC41NyAwIDAwLTI4Mi41IDExNyAzOTcuNDcgMzk3LjQ3IDAgMDAtODUuNiAxMjdDODIuNiA0NDYuMiA3MiA0OTguNSA3MiA1NTIuNVM4Mi42IDY1OC43IDEwMy40IDcwOGMyMC4xIDQ3LjUgNDguOSA5MC4zIDg1LjYgMTI3IDM2LjcgMzYuNyA3OS40IDY1LjUgMTI3IDg1LjZhMzk2LjY0IDM5Ni42NCAwIDAwMTU1LjYgMzEuNSAzOTguNTcgMzk4LjU3IDAgMDAyODIuNS0xMTdjMzYuNy0zNi43IDY1LjUtNzkuNCA4NS42LTEyN2EzOTYuNjQgMzk2LjY0IDAgMDAzMS41LTE1NS42di0yNmMtLjEtNC40LTMuNy04LTguMS04ek05NTEgNDYzbC0yLjYtMjguMmMtOC41LTkyLTQ5LjMtMTc4LjgtMTE1LjEtMjQ0LjNBMzk4LjUgMzk4LjUgMCAwMDU4OC40IDc1LjZMNTYwLjEgNzNjLTQuNy0uNC04LjcgMy4yLTguNyA3Ljl2MzgzLjdjMCA0LjQgMy42IDggOCA4bDM4My42LTFjNC43LS4xIDguNC00IDgtOC42eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/React.forwardRef(PieChartFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PieChartFilled';
}
var _default = exports.default = RefIcon;